<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  //$fa-font-path: '~font-awesome/fonts/';
  //@import '~font-awesome/scss/font-awesome.scss';
  $fa-font-path: "~@fortawesome/fontawesome-pro/webfonts/";
  @import '~@fortawesome/fontawesome-pro/scss/fontawesome.scss';
  @import '~@fortawesome/fontawesome-pro/scss/regular.scss';
  @import '~@fortawesome/fontawesome-pro/scss/solid.scss';
  @import '~@fortawesome/fontawesome-pro/scss/light.scss';
  @import '~@fortawesome/fontawesome-pro/scss/brands.scss';
  @import '~@fortawesome/fontawesome-pro/scss/v4-shims.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
